// Our main CSS
import '../css/app.css'

declare global {
  interface Window {
    INTEREST_FORM_ENDPOINT: string
  }
}

const site_header = document.querySelector('header') as HTMLElement
if (site_header) {
  import('./modules/header').then(({ default: init }) => {
    init(site_header)
  })
}

const site_intro_animation = document.querySelector('.acf-intro-block') as HTMLElement

// Handle header scroll state - adds class when scrolled past intro
if (site_header) {
  import('./modules/header-scroll-state').then(({ default: init }) => {
    init(site_header, site_intro_animation)
  })
}

const gallery_triggers = document.querySelectorAll('.js-toggle-gallery') as NodeListOf<HTMLElement>
if (gallery_triggers?.length) {
  gallery_triggers.forEach(async (elem) => {
    await import('./modules/gallery').then((module) => {
      module.default(elem)
    })
  })
}

// Mobile tap state for nav links
const main_nav = document.querySelector('.MainNav') as HTMLElement
if (main_nav) {
  import('./modules/mobile-tap-state').then(({ default: init }) => {
    init(main_nav)
  })
}

if (site_intro_animation) {
  document.body.classList.add('has-intro')
  import('./modules/site-intro-animation').then(({ default: init }) => {
    init(site_intro_animation)
  })
} else {
  document.body.classList.add('no-intro')
}

const expandable_toggles = document.querySelectorAll('.js-expandable-toggle') as NodeListOf<HTMLElement>
if (expandable_toggles?.length) {
  expandable_toggles.forEach(async (elem) => {
    await import('./modules/expandable-sections').then((module) => {
      module.default(elem)
    })
  })
}

const image_columns_blocks = document.querySelectorAll('.ImageColumnsBlock') as NodeListOf<HTMLElement>
if (image_columns_blocks?.length) {
  image_columns_blocks.forEach(async (elem) => {
    await import('./modules/image-columns').then((module) => {
      module.default(elem)
    })
  })
}

const initNonCritical = async () => {
  const aparment_selectors = document.querySelectorAll('.ApartmentSelectorApp')
  if (aparment_selectors?.length) {
    aparment_selectors.forEach(async (elem) => {
      await import('./modules/apartment-selector').then((module) => {
        module.default(elem as HTMLElement)
      })
    })
  }

  const interest_forms = document.querySelectorAll(
    '[data-block="interest-form-block"]:not([x-data])'
  ) as NodeListOf<HTMLElement>

  if (interest_forms?.length) {
    try {
      for (const form of interest_forms) {
        const module = await import('./modules/interest-form')
        module.default(form)
      }
    } catch (error) {
      console.error('Error initializing interest forms:', error)
    }
  }

  const apartment_table = document.querySelectorAll(
    '[data-apartment-table]'
  ) as NodeListOf<HTMLElement>
  if (apartment_table?.length) {
    apartment_table.forEach(async (elem) => {
      await import('./modules/apartment-table-list').then((module) => {
        module.default(elem as HTMLElement)
      })
    })
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}
